import React from "react";

const SignUp = () => (
  <div className="signup__container">
    <p className="signup__text">
      Want to organize a delivery for your neighborhood?
    </p>
    <a
      className="button signup__button"
      href="https://forms.gle/x6PHyDfH9GZFvd5N8"
    >
      Sign up to be a community captain
    </a>
  </div>
);

export default SignUp;
